import type { PaymentSource, PaymentSourceFilter } from "./types";

/** How a payment was taken, as shown in tables and on the payment. */
export const SOURCE_LABELS: Record<PaymentSource, string> = {
  payment_link: "Payment link",
  api_checkout: "API · Checkout",
  api_headless: "API · Headless",
  api: "API",
};

/** The Payments page's source filter; undefined is every source. */
export const SOURCE_FILTERS: Array<{ source: PaymentSourceFilter | undefined; label: string }> = [
  { source: undefined, label: "All" },
  { source: "payment_link", label: "Payment links" },
  { source: "api_checkout", label: "API · Checkout" },
  { source: "api_headless", label: "API · Headless" },
];
